import { render, staticRenderFns } from "./Detail-Adjustment.vue?vue&type=template&id=e45becd4"
import script from "./Detail-Adjustment.vue?vue&type=script&lang=js"
export * from "./Detail-Adjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports